import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const CakeCard = ({ cake, attributes }) => {
  const navigate = useNavigate();

  const handleGoToDetails = () => {
    if (window.fbq) {
      window.fbq("trackCustom", "CustomizeAndOrderClick", {
        content_name: cake.displayName,
        content_ids: [cake._id],
        content_type: "product",
        value: cake.basePrice,
        currency: "CAD",
      });
    }

    navigate(`/shop/cakes/specialty-cakes/${cake._id}`);
  };

  const allAttributes = [
    ...(attributes.decor || []),
    ...(attributes.style || []),
    ...(attributes.texture || []),
  ];

  const styleTags = allAttributes
    .filter(
      (attr) => attr.type === "style" && cake.attributes.includes(attr._id)
    )
    .map((attr) => attr.name)
    .join(" · ");

  return (
    <Card
      sx={{
        borderRadius: 3,
        transition: "box-shadow 0.3s, transform 0.3s",
        boxShadow: 1,
        "&:hover": {
          boxShadow: 5,
          transform: "scale(1.02)",
        },
      }}>
      <Box sx={{ position: "relative" }}>
        <CardMedia
          component="img"
          height="400px"
          width="100%"
          image={cake.images?.primary || "/images/placeholder.jpg"}
          alt={cake.name}
          sx={{
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            objectFit: "cover",
          }}
        />

        {/* Optional badge */}
        {cake.isFeatured && (
          <Chip
            label="Featured"
            size="small"
            sx={{
              position: "absolute",
              top: 12,
              left: 12,
              backgroundColor: "primary.main",
              color: "white",
              fontWeight: 600,
            }}
          />
        )}
      </Box>

      <CardContent>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          {cake.displayName}
        </Typography>

        {styleTags && (
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", opacity: 0.75 }}>
            {styleTags}
          </Typography>
        )}

        <Typography variant="body1" fontWeight={500} sx={{ mt: 1.5 }}>
          Starting at ${cake.basePrice}
        </Typography>

        <Button
          variant="contained"
          fullWidth
          sx={{
            mt: 2,
            py: 1.25,
            borderRadius: 2,
            fontWeight: 600,
            backgroundColor: "primary.main",
            "&:hover": {
              background: "linear-gradient(90deg, #fd7762 0%, #f9a98f 100%)",
            },
          }}
          onClick={handleGoToDetails}>
          Customize & Order
        </Button>
      </CardContent>
    </Card>
  );
};

export default CakeCard;
